import React from 'react'
import { connect } from 'react-redux';
import { Col, Button } from 'reactstrap'
import DateRangePicker, { validator } from './DateRangePicker'
import { getSalesReport } from '../../api/giftApi';
import PopupError from '../PopupError';
import { downloadFile } from '../../helpers/download';
import { getAllClubs } from "../../api/clubapi";
import { getBranches } from "../../api/productapi";
import ClubBranchSelect from './ClubBranchSelect';
import { customLoadingOverlay } from '../css/CustomLoadingOverlay'
import LoadingOverlay from 'react-loading-overlay-ts'
import ReportTypes from './reportTypes'

class SalesReport extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            branchId: '-1',
            branchName: '',
            clubId: '-1',
            clubName: '',
            startDate: '',
            endDate: '',
            validation: validator.valid(),
            error: false,
            errorMessage: [],
        }
    }

    componentDidMount() {
        if (this.props.branches.length === 0 || this.props.clubs.length === 0)
            this.setState({ loading: true })
        if (this.props.branches.length === 0)
            this.props.getBranches(function (result, _this) { }, this)
        if (this.props.clubs.length === 0)
            this.props.getAllClubs(function (result, _this) { }, this)
    }

    componentDidUpdate(prevProps) {
        const clubsUpdated = prevProps.clubs !== this.props.clubs
        const branchesUpdated = prevProps.branches !== this.props.branches
        if (clubsUpdated || branchesUpdated)
            this.setState({ loading: false })
    }

    setClub = (clubId, clubName) => this.setState({ clubId, clubName })
    setBranch = (branchId, branchName) => this.setState({ branchId, branchName })

    handleDownload = _ => {
        const startDate = document.getElementById("startDate").value;
        const endDate = document.getElementById("endDate").value;
        this.setState({ startDate, endDate }, () => { this.download() })
    }

    download() {
        const validation = validator.validate(this.state);
        this.setState({ validation });
        if (validation.isValid) {
            getSalesReport(this.state.clubId, this.state.branchId, this.state.startDate, this.state.endDate)
                .then(r => downloadFile(r))
                .catch(e => {
                    const errorList = e.response.data.errors.map(e => e.message)
                    this.setState({ error: true, errorMessage: errorList })
                })
        }
    }

    closeModal = () => this.setState({ error: false })

    render() {
        return <LoadingOverlay active={this.state.loading} spinner styles={customLoadingOverlay} >
            <PopupError
                open={this.state.error}
                onClose={this.closeModal}
                onClick={this.closeModal}
                errorMessage={this.state.errorMessage} />
            {this.props.clubs.length > 0 && this.props.branches.length > 0 && <ClubBranchSelect
                clubId={this.state.clubId}
                setClub={this.setClub}
                branchId={this.state.branchId}
                setBranch={this.setBranch}
                clubs={this.props.clubs}
                branches={this.props.branches}
                reportType={ReportTypes.SalesReport} />}
            <DateRangePicker
                startDate={this.state.startDate}
                endDate={this.state.endDate}
                validation={this.state.validation}
                fieldName='salesReport' />
            <Col className="text-right float-bottom">
                <Button onClick={this.props.handleCancel} className="cancel-btn">CANCEL</Button>
                <Button onClick={this.handleDownload} type="submit" color="primary" className='save-btn'>DOWNLOAD</Button>
            </Col>
        </LoadingOverlay>
    }
}

export default connect(
    state => ({
        branches: state.data.branches,
        clubs: state.data.clubs,
    }),
    dispatch => ({
        getBranches: (callback, context) => { dispatch(getBranches(callback, context)) },
        getAllClubs: (callback, context) => { dispatch(getAllClubs(callback, context)) },
    })
)(SalesReport)